import React, { useState } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const styles = {
  container: {
    fontFamily: "'Comic Sans MS', cursive, sans-serif",
    background: "#fff3e0",
    color: "#4e342e",
    textAlign: "center",
    padding: 20,
    minHeight: "100vh",
    boxSizing: "border-box",
  },
  title: {
    color: "#d84315",
    marginBottom: 8,
  },
  description: {
    maxWidth: 480,
    margin: "0 auto 30px",
    fontSize: 16,
    lineHeight: 1.4,
  },
  groupsWrapper: {
    display: "flex",
    justifyContent: "center",
    gap: 30,
    flexWrap: "wrap",
  },
  groupBox: {
    background: "#ffe0b2",
    borderRadius: 15,
    boxShadow: "2px 2px 6px #bbb",
    padding: 15,
    width: 280,
    boxSizing: "border-box",
  },
  groupTitle: {
    marginBottom: 10,
  },
  inputsWrapper: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  input: {
    width: 60,
    padding: 6,
    fontSize: "1.1rem",
    textAlign: "center",
    borderRadius: 8,
    border: "2px solid #d84315",
    boxSizing: "border-box",
  },
  button: {
    fontSize: "1.1rem",
    padding: "10px 20px",
    marginTop: 20,
    backgroundColor: "#d84315",
    color: "white",
    border: "none",
    borderRadius: 12,
    cursor: "pointer",
  },
  buttonHover: {
    backgroundColor: "#bf360c",
  },
  results: {
    marginTop: 30,
    fontSize: "1.3rem",
    minHeight: 40,
    maxWidth: 500,
    marginLeft: "auto",
    marginRight: "auto",
  },
  highlight: {
    backgroundColor: "#c8e6c9",
    border: "3px solid #388e3c",
  },
  slower: {
    backgroundColor: "#ffcdd2",
    border: "3px solid #c62828",
  },
};

export default function AverageRace() {
  // 5 inputs per group
  const [timesA, setTimesA] = useState(Array(5).fill(""));
  const [timesB, setTimesB] = useState(Array(5).fill(""));
  const [resultMsg, setResultMsg] = useState("");
  const [highlightA, setHighlightA] = useState("");
  const [highlightB, setHighlightB] = useState("");

  const handleInputChange = (group, index, value) => {
    const val = value.replace(/[^0-9.]/g, ""); // Allow numbers and dot only
    if (group === "A") {
      const newTimes = [...timesA];
      newTimes[index] = val;
      setTimesA(newTimes);
    } else {
      const newTimes = [...timesB];
      newTimes[index] = val;
      setTimesB(newTimes);
    }
  };

  const calculateAverage = (arr) => {
    const nums = arr.map(parseFloat).filter((v) => !isNaN(v));
    if (nums.length < 2) return null;
    const sum = nums.reduce((a, b) => a + b, 0);
    return sum / nums.length;
  };

  const onCheck = () => {
    const avgA = calculateAverage(timesA);
    const avgB = calculateAverage(timesB);

    if (avgA === null || avgB === null) {
      setResultMsg("Please enter at least 2 valid times in each group.");
      setHighlightA("");
      setHighlightB("");
      return;
    }

    let msg = `🅰️ Group A average: ${avgA.toFixed(2)}s\n🅱️ Group B average: ${avgB.toFixed(2)}s\n\n`;

    if (avgA < avgB) {
      msg += "🏆 Group A is faster!";
      setHighlightA("highlight");
      setHighlightB("slower");
    } else if (avgB < avgA) {
      msg += "🏆 Group B is faster!";
      setHighlightB("highlight");
      setHighlightA("slower");
    } else {
      msg += "It's a tie! Both groups have the same average speed.";
      setHighlightA("");
      setHighlightB("");
    }
    setResultMsg(msg);
    const responsedata = ConstructorEventUpdateSQLStatus();
    console.log("Event completed", responsedata);
  };

  const onReset = () => {
    setTimesA(Array(5).fill(""));
    setTimesB(Array(5).fill(""));
    setResultMsg("");
    setHighlightA("");
    setHighlightB("");
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🏁 Average Race</h1>
      <p style={styles.description}>
        Enter the race times (in seconds) for each runner in the two groups. Then find out which group
        is faster on average!
      </p>

      <div style={styles.groupsWrapper}>
        <div
          style={{
            ...styles.groupBox,
            ...(highlightA === "highlight"
              ? styles.highlight
              : highlightA === "slower"
                ? styles.slower
                : {}),
          }}
        >
          <h2 style={styles.groupTitle}>Group A</h2>
          <div style={styles.inputsWrapper}>
            {timesA.map((val, i) => (
              <input
                key={i}
                type="number"
                min="1"
                placeholder="sec"
                value={val}
                onChange={(e) => handleInputChange("A", i, e.target.value)}
                style={styles.input}
              />
            ))}
          </div>
        </div>

        <div
          style={{
            ...styles.groupBox,
            ...(highlightB === "highlight"
              ? styles.highlight
              : highlightB === "slower"
                ? styles.slower
                : {}),
          }}
        >
          <h2 style={styles.groupTitle}>Group B</h2>
          <div style={styles.inputsWrapper}>
            {timesB.map((val, i) => (
              <input
                key={i}
                type="number"
                min="1"
                placeholder="sec"
                value={val}
                onChange={(e) => handleInputChange("B", i, e.target.value)}
                style={styles.input}
              />
            ))}
          </div>
        </div>
      </div>

      <button style={styles.button} onClick={onCheck}>
        Compare Averages
      </button>
      <button
        style={{
          ...styles.button,
          marginLeft: 10,
          backgroundColor: "#888",
          cursor: "pointer",
        }}
        onClick={onReset}
      >
        Reset
      </button>

      <pre style={styles.results}>{resultMsg}</pre>
    </div>
  );
}
